import { api, getAuthorizationToken } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import {
  subDocTypeCreate,
  subDocTypeCreateCopy,
  subDocTypeEdit,
} from 'src/types';

export default class DocumentSubTypesApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async get(doc_type: string): Promise<any> {
    const data = { doc_type_key: doc_type };
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_sub_document_types + '?' + querystring, {});
  }

  public async delete(id: string): Promise<any> {
    return super.delete(api.delete_sub_document_type + '/' + id, {});
  }

  public async create(data: subDocTypeCreate): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.create_sub_document_type, formData);
  }

  public async createCopy(data: subDocTypeCreateCopy): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.create_copy_sub_document_type, formData);
  }

  public async edit(data: subDocTypeEdit): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.edit_sub_document_type, formData);
  }
}
